"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = index;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var Container = _styledComponents.default.div.withConfig({
  displayName: "CustomgOverlayContainer__Container",
  componentId: "sc-100pp7p-0"
})(["position:relative;bottom:", ";"], function (_ref) {
  var bottom = _ref.bottom;
  return bottom;
});

function index(_ref2) {
  var content = _ref2.content,
      bottom = _ref2.bottom;
  return _react.default.createElement(Container, {
    bottom: bottom
  }, content);
}